import axiosInstance from "../api/axiosInstance"

// GET: List users with pagination, filters, search
export const fetchUsers = (params) => axiosInstance.get("/admin/userList", { params });

// GET: Get single user details by ID
export const getUserById = (id) => axiosInstance.get(`/admin/userDetails/${id}`);

// Signup date + why a member deleted (works for deleted accounts).
export const getUserLifecycle = (id) => axiosInstance.get(`/admin/user-lifecycle/${id}`);

export const getChurnRisk = (params) => axiosInstance.get(`/admin/churn-risk`, { params });

// Possible duplicates (founder decision 2026-10-13, backend utils/dupeFlag).
// Review only: the list (state new | reviewed | dismissed | all), the
// founder's answer on a pair, and a scan (refused while dupe_flag_v1 is OFF).
export const getPossibleDuplicates = (params) => axiosInstance.get(`/admin/duplicates`, { params });
export const setDuplicateState = (id, state) => axiosInstance.post(`/admin/duplicates/${id}/state`, { state });
export const scanDuplicates = () => axiosInstance.post(`/admin/duplicates/scan`, {});
// Smart download link (curiouzz.com/get) hits, per ?src= channel.
export const getDownloadHits = (params) => axiosInstance.get(`/admin/download-hits`, { params });

// PUT: Update user profile by ID
export const updateUser = (id, data) => axiosInstance.put(`/admin/updateUser/${id}`, data);

// PATCH: Ban or unban user
export const changeUserStatus = (id, data) => axiosInstance.patch(`/admin/banUser/${id}`, data);

// DELETE: Soft delete a user
export const deleteUser = (id) => axiosInstance.delete(`/admin/deleteUser/${id}`);

// DELETE: HARD delete - permanent, irreversible removal (junk cleanup).
export const hardDeleteUser = (id) => axiosInstance.delete(`/admin/hard-delete-user/${id}`);

// Bulk permanent delete of the explicitly selected ids.
export const hardDeleteUsersBulk = (ids) => axiosInstance.post(`/admin/hard-delete-users`, { ids });

// DELETE: Soft delete all user
export const deleteUserAll = (id) => {
  return axiosInstance.delete("/admin/deleteUserAll", {
    data: { id },
  });
};
// POST: Add admin note to user profile

export const addAdminNote = (id, adminNotes) => {
  return axiosInstance.post(`/admin/addNote/${id}`, {
    adminNotes,
  });
};


// GET: Fetch user activity log (edits, bans, matches, chats, purchases, etc.)

export const getUserActivityLog = (id, params) =>
  axiosInstance.get(`/admin/activityLog/${id}`, { params });


export const getUserReportsAPI = (params) => {
  return axiosInstance.get("/admin/userReports", { params });
};

export const addCoinsAPI = (userId, data) => {
  return axiosInstance.post(`/admin/coins/add/${userId}`, data);
};


export const deleteUserPhotoAPI = (userId, data) => {
  return axiosInstance.delete(`/admin/user/${userId}/photo`, { data });
};


// Pause / resume introductions (founder go 2026-09-27). Support pauses a
// member only on their own written request. The note (1 to 300 characters)
// is required both ways and lands in the admin notes and the activity log;
// the reason is the optional chip the 2.4 sheet offers. Nothing is sent to
// the member: support replies to them itself.
export const pauseIntroductions = (id, { note, reason }) =>
  axiosInstance.post(`/admin/users/${id}/intro-pause`, reason ? { note, reason } : { note });

export const resumeIntroductions = (id, { note }) =>
  axiosInstance.post(`/admin/users/${id}/intro-resume`, { note });

// "Name needs a look" (2.6, founder 2026-10-15, backend
// controllers/admin.nameReview.js). Only for a member flagged right now: the
// server refuses (409) anyone else, so an existing member's name can never
// be changed from here. Rename runs the sign-up name rules (a refused name is
// a 400 with the member's own message) and sends the first word to the chat;
// Looks fine only clears the flag. Nothing is sent to the member.
export const renameFlaggedName = (id, name) => axiosInstance.post(`/admin/users/${id}/name-review/rename`, { name });
export const nameLooksFine = (id) => axiosInstance.post(`/admin/users/${id}/name-review/looks-fine`, {});

// Live host role (founder go 2026-10-12, backend utils/staffRole): on = staff
// for Curiouzz Live, never introduced; off = an ordinary member again.
export const setLiveHost = (id, { on, note }) =>
  axiosInstance.post(`/admin/users/${id}/live-host`, note ? { on: !!on, note } : { on: !!on });

export const grantTrialToUsers = async ({ userIds = [], duration = 1, notifyUsers = true, reason }) => {
  return await axiosInstance.post("/admin/grantTrial", {
    userIds,
    duration,
    notifyUsers,
    reason,
  });
};